<template>
  <el-row>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-row type="flex" class="row-bg">
          <el-col :span="23">
            <span class="cadastro-title">Árvore - List</span>
          </el-col>
          <el-col :span="1">
            <el-button @click="linkToTemplate()" type="success" icon="el-icon-download"
                       class="pull-right mr-1">
            </el-button>
          </el-col>
          <el-col :span="1">
            <router-link to="/arvore/create">
              <el-button type="primary" icon="el-icon-plus"></el-button>
            </router-link>
          </el-col>
        </el-row>
      </div>
      <div class="row" v-loading="isLoading">
        <div class="col">
          <data-tables :data="list" :table-props="tableProps">
            <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.label"
                             sortable="custom">
            </el-table-column>
            <el-table-column label="Ações" min-width="100px">
              <template slot-scope="scope">
                <el-dropdown>
                  <el-button size="mini" type="primary">Ações<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="visualizar(scope.row.id)">Visualizar</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </data-tables>
        </div>
      </div>
    </el-card>
  </el-row>
</template>
<style scoped>
  .card-title {
    font-size: 1.1em;
    font-weight: bold;
  }
</style>
<script>
  import FileSaver from 'file-saver'
  import {mapActions, mapState} from 'vuex'

  export default {
    name: "arvore-index",
    data() {
      return {
        isLoading: false,
        titles: [{prop: 'id', label: '#'},
          {prop: 'nome', label: 'Nome'}],
        tableProps: {
          border: false,
          stripe: true
        }
      }
    },
    computed: {
      ...mapState('Arvore', ['list'])
    },
    methods: {
      ...mapActions('Arvore', ['setList']),
      visualizar(id) {
        this.$router.push({name: 'arvore.show', params: {id}})
      },
      async linkToTemplate() {
        this.isLoading = true
        try {
          const {data} = await axios.get(`${process.env.API_URI_PATH}/arvore/template`, {responseType: 'blob'})
          const file = new Blob([data], {type: "application/vnd.openxmlformats-olefficedocument.spreadsheetml.sheet;charset=utf-8"});
          FileSaver.saveAs(file, `arvore_template_nova.xlsx`);
        } catch (e) {

        } finally {
          this.isLoading = false
        }
      }
    },
    async mounted() {
      try {
        this.isLoading = true
        await this.setList()
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }

    }
  }
</script>





// WEBPACK FOOTER //
// src/features/Arvore/index.vue